"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TypographyStyles.Typography;
  }
});

var _TypographyStyles = require("./Typography-styles");